import { useErrorBoundary } from 'react-error-boundary';
import { toast } from 'sonner';

export const useHandleError = () => {
  const { showBoundary } = useErrorBoundary();

  return (errors: Array<any | null | undefined>) => {
    const error = errors.find((error) => error);

    if (error) {
      const { code } = error.data || {};
      switch (code) {
        case 'NOT_FOUND':
          toast(error.message, {
            classNames: {
              toast: 'bg-red-400 text-white border-0',
            },
            duration: 3000,
          });
          break;
        case 'FORBIDDEN':
          toast(error.message, {
            classNames: {
              toast: 'bg-red-400 text-white border-0',
            },
            duration: 3000,
          });
          break;
        case 'INTERNAL_SERVER_ERROR':
          toast(error.message, {
            classNames: {
              toast: 'bg-red-400 text-white border-0',
            },
            description: 'Please retry after a few seconds.',
            duration: 3000,
          });
          break;
        default:
          showBoundary(error);
          break;
      }
    }
  };
};
